<template>
  <div
    class="inscription-card group"
    v-bind:class="[
      { 'inscription-card--head-list cursor-pointer': parcours },
      {
        [`cursor-pointer hover:shadow-lg`]:
          inscription.accesDetails && !parcours
      },
      {
        'inscription-card-disabled':
          isFormateurStatusCancel || (!inscription.accesDetails && !parcours)
      }
    ]"
    v-on:click="cardAction">
    <div class="card__container">
      <div
        class="card__container--anchor"
        v-bind:class="type_anchor_color(inscription.type[0].id)"></div>

      <div class="container__content">
        <div class="content__type">
          <div
            v-for="{ id, label } in inscription.type"
            v-bind:key="id"
            class="type__label"
            v-bind:class="type_bg_color(id)">
            <span>{{ label }}</span>
          </div>
        </div>

        <div class="content__description">
          <InscriptionCardLeft
            v-bind:inscription="inscription"
            v-bind:parcours="parcours"
            v-bind:collapsed="collapsed"
            v-bind:produit="produit" />
          <InscriptionCardRight
            v-bind:inscription="inscription"
            v-bind:parcours="parcours"
            v-bind:collapsed="collapsed"
            v-bind:produit="produit" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { map_type_colors } from '@/assets/data/data_maps.js';
  import dates_helpers from '@/mixin/dates_helpers';
  import http_functions from '@/mixin/http_functions';
  import InscriptionCardLeft from '../_inscription-card/inscription-card-left.vue';
  import InscriptionCardRight from '../_inscription-card/inscription-card-right.vue';

  export default {
    components: {
      InscriptionCardLeft,
      InscriptionCardRight
    },
    mixins: [dates_helpers, http_functions],
    props: {
      inscription: {
        type: Object,
        default: null
      },
      parcours: {
        type: Boolean,
        default: false
      },
      collapsed: {
        type: Boolean,
        default: null
      },
      toggle_collapse: {
        type: Function,
        default: null
      },
      espace: { type: String },
      produit: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        map_type_colors
      };
    },
    computed: {
      isSessionStatusCancel() {
        return this.inscription?.sessionStatut?.id === 5;
      },
      isFormateurStatusCancel() {
        return this.inscription?.formateurStatut?.id === 3;
      }
    },
    methods: {
      type_anchor_color(id) {
        return `border-${map_type_colors[id]}`;
      },
      type_bg_color(id) {
        return `bg-${map_type_colors[id]}`;
      },
      goToDetails() {
        const { reference } = this.inscription;

        if (reference) {
          this.$router.push(
            `/formateur/session-details?reference=${reference}`
          );
        }
      },
      cardAction() {
        if (this.toggle_collapse) {
          this.toggle_collapse();
        } else {
          const is_detail_available =
            (this.inscription.accesDetails &&
              !this.parcours &&
              !this.isSessionStatusCancel) ||
            !this.isFormateurStatusCancel;

          is_detail_available ? this.goToDetails() : null;
        }
      }
    }
  };
</script>

<style lang="scss" scoped>
  @use '@/assets/css/utils/mixins' as mixin;

  .inscription-card {
    @apply mb-4 flex overflow-hidden rounded-lg bg-white shadow transition;

    &.inscription-card--head-list {
      @apply shadow-lg;
      &:hover .content__title {
        @apply text-primary-700;
      }
    }

    &.inscription-card-disabled {
      @apply cursor-not-allowed text-accent-500 hover:bg-core-200 hover:text-accent-400 hover:shadow-sm;
    }

    .card__container {
      @apply relative flex w-full items-center;

      .card__container--anchor {
        @apply absolute left-0 top-0 z-10 h-10 w-12 border-l-8 border-t-8;
      }

      .container__content {
        @apply relative h-full w-full py-5 pl-4 pr-3 tracking-tight shadow;

        .content__type {
          @apply absolute right-0 top-0 mr-2 mt-2 flex space-x-2;
          .type__label {
            @apply rounded-full px-3 py-0.5 text-xs font-bold lowercase text-core-100 shadow first-letter:capitalize;
          }
        }

        .content__title {
          @apply mb-4 text-xl font-bold leading-tight;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          @supports (-webkit-line-clamp: 2) {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: initial;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
          }

          .content__title__legend {
            @apply ml-2 inline-flex cursor-pointer items-center space-x-2 text-sm font-normal leading-none text-core-700 text-transparent transition;
            .title__legend__icon,
            .title__legend__text {
              @apply transition ease-in;
            }
          }
        }

        .content__reference {
          @apply mb-2 text-accent-500;
        }

        .content__description {
          @apply mt-6 flex flex-wrap items-end justify-between text-sm md:mt-4 md:flex-nowrap;

          .description__left {
            @apply w-full flex-grow self-start pl-5 pr-3;
          }

          .description__right {
            @apply mt-6 flex w-full flex-wrap px-4 md:w-120 md:justify-end;
            > div {
              @apply flex w-full justify-end;
            }
          }
        }
      }
    }
  }
</style>
